import React, { FC, memo, ReactNode } from "react"
import { Button } from "@/ui/Button/Button"
import { TotalControls } from "./StyledFilter"

export type ToralControlsPropsType = {
  clear: () => void
  apply: () => void
  isExist: boolean
  applyContent?: ReactNode
}

const Total: FC<ToralControlsPropsType> = memo(
  ({ clear, apply, isExist, applyContent }) => {
    return (
      <TotalControls>
        <Button
          variant={"outline"}
          size={"large"}
          onClick={clear}
          disabled={!isExist}
        >
          Сбросить все
        </Button>
        <Button variant={"filled"} size={"large"} onClick={apply}>
          {!!applyContent ? applyContent : "Применить"}
        </Button>
      </TotalControls>
    )
  },
)

Total.displayName = "Total"
export { Total }
